var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"font-size":"2rem","text-align":"center","padding":"4rem"}},[_vm._v("Vui lòng đợi ...")])}
var staticRenderFns = []

export { render, staticRenderFns }